/* eslint-disable no-return-await */
import axios from 'axios';
import { API_URL, getCachedSessionId } from './common';

const getDomainAvailable = async (name, tld) => {
  return axios.get(`${API_URL}/v1/domains/available`, {
    headers: { token: 'dummy' },
    params: {
      name,
      tld
    }
  });
};

const confirmPayment = async (items) => {
  return await axios.post(
    `${API_URL}/v1/cart/confirmPayment`,
    { items },
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );
};

const getDomains = async (status = 'active') => {
  return await axios.get(`${API_URL}/v1/domains`, {
    headers: { 'x-session-id': getCachedSessionId() },
    params: { status }
  });
};

const getDomainByName = async (name) => {
  return await axios.get(`${API_URL}/v1/domains/${name}`, {
    headers: { 'x-session-id': getCachedSessionId() }
  });
};

const getDomainTransfers = async () => {
  return await axios.get(`${API_URL}/v1/domains/transfers`, {
    headers: { 'x-session-id': getCachedSessionId() }
  });
};

const createDomainTransfer = async (name, authCode) => {
  return await axios.post(
    `${API_URL}/v1/domains/transfers`,
    { authCode, name },
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );
};

const updateDomain = async (name, body) => {
  return await axios.put(`${API_URL}/v1/domains/${name}`, body, {
    headers: { 'x-session-id': getCachedSessionId() }
  });
};

const updateDomainRecord = async (name, recordId, body) => {
  return await axios.put(`${API_URL}/v1/domains/${name}/records/${recordId}`, body, {
    headers: { 'x-session-id': getCachedSessionId() }
  });
};

const createDomainRecord = async (name, body) => {
  return await axios.post(`${API_URL}/v1/domains/${name}/records`, body, {
    headers: { 'x-session-id': getCachedSessionId() }
  });
};

const deleteDomainRecord = async (name, id) => {
  return await axios.delete(`${API_URL}/v1/domains/${name}/records/${id}`, {
    headers: { 'x-session-id': getCachedSessionId() }
  });
};

const deleteDomain = async (projectId, id) => {
  return await axios.delete(`${API_URL}/v1/project/${projectId}/provider/domain/${id}`, {
    headers: { 'x-session-id': getCachedSessionId() }
  });
};

const getAllDomains = async (projectId) => {
  return await axios.get(`${API_URL}/v1/project/${projectId}/provider/domain`, {
    headers: { 'x-session-id': getCachedSessionId() }
  });
};

export {
  getDomainAvailable,
  confirmPayment,
  getDomains,
  getDomainByName,
  getDomainTransfers,
  createDomainTransfer,
  updateDomain,
  updateDomainRecord,
  createDomainRecord,
  deleteDomainRecord,
  deleteDomain,
  getAllDomains
};
